import { gql } from 'apollo-angular';

const GET_CROSSES_BY_DISTRIBUTOR = gql`
  query getCrosses(
    $searchValue: String!
    $categoryId: Long!
    $distributorId: Long!
    $variant: String
  ) {
    optimizedPurchasedProducts(
      variant: $variant
      searchCriteria: {
        limit: 50
        searchValue: $searchValue
        boostCriteria: { fieldName: "categoryId", fieldValue: $categoryId }
        filterCriteria: {
          fieldName: "distributorId"
          fieldValue: $distributorId
        }
      }
    ) {
      id
      brandName
      catalogNumber
      manufacturerCatalogNumber
      description
      status
      packageString
      productSource
      categories {
        id
        name
        parents {
          id
          name
        }
      }
      manufacturer {
        id
        name
      }
      parentManufacturer {
        id
        name
      }
      distributor {
        id
        name
      }
      parentDistributor {
        id
        name
      }
    }
  }
`;

export default GET_CROSSES_BY_DISTRIBUTOR;
